import {
  LayoutDashboard, Store, Truck, Wallet, Pill, ShieldAlert,
  ClipboardList, Map, TrendingUp, CalendarCheck, Settings, ChevronLeft, ChevronRight, ChevronDown,
  Sun, Moon, Monitor, LogOut, Menu, Warehouse, NotebookPen, Globe, Building2, Eye, Bell, MessageCircle, Activity,
  Plus, Search, X, FileText, DollarSign, Boxes, Package, Waves, Briefcase, Leaf, Users, Shield, BarChart3,
  AlertTriangle, HelpCircle, MessageSquarePlus, Link2, Crown, Camera, Loader2, TicketCheck, Database, Command, Upload, ClipboardCheck,
  Sparkles, CalendarDays, Brain, Car,
} from 'lucide-react';

// ============ ROLE-BASED NAVIGATION ============
// Platform = HIDDEN INTERNAL | Admin = CONTROL | Manager = OPERATE | MR = EXECUTE | Apteka = VIEW + BENEFIT

export const PLATFORM_SECTIONS = [
  {
    key: 'overview', label: '',
    items: [
      { path: '/internal/control-room#overview', labelKey: 'dashboard', icon: LayoutDashboard, permKey: null },
    ]
  },
  {
    key: 'workspaces', label: 'Workspaces',
    items: [
      { path: '/internal/control-room#workspaces', labelKey: 'allWorkspaces', icon: Globe, permKey: null },
      { path: '/internal/control-room#companies', labelKey: 'companies', icon: Building2, permKey: null },
      { path: '/internal/control-room#pharmacies', labelKey: 'pharmacies', icon: Store, permKey: null },
    ]
  },
  {
    key: 'data', label: 'Data',
    items: [
      { path: '/internal/control-room#partners', labelKey: 'partners', icon: Users, permKey: null },
      { path: '/internal/control-room#catalog', labelKey: 'catalog', icon: Package, permKey: null },
      { path: '/internal/control-room#connections', labelKey: 'connections', icon: Link2, permKey: null },
    ]
  },
  {
    key: 'operations', label: 'Operations',
    items: [
      { path: '/internal/control-room#subscriptions', labelKey: 'subscription', icon: Crown, permKey: null },
      { path: '/internal/control-room#tickets', labelKey: 'tickets', icon: TicketCheck, permKey: null },
    ]
  },
  {
    key: 'system', label: 'System',
    items: [
      { path: '/internal/control-room#audit', labelKey: 'auditLog', icon: FileText, permKey: null },
      { path: '/internal/control-room#backup', labelKey: 'backup', icon: Database, permKey: null },
      { path: '/internal/control-room#import', labelKey: 'import', icon: Upload, permKey: null },
      { path: '/internal/control-room#checklist', labelKey: 'checklist', icon: ClipboardCheck, permKey: null },
    ]
  },
];

export const ADMIN_SECTIONS = [
  {
    key: 'main', label: '',
    items: [
      { path: '/dashboard', labelKey: 'dashboard', icon: LayoutDashboard, permKey: 'dashboard',
        children: [
          { path: '/dashboard', labelKey: 'dashboard', permKey: 'dashboard' },
          { path: '/exceptions', labelKey: 'exceptions', permKey: 'dashboard' },
          { path: '/district-summary', labelKey: 'districtSummary', permKey: 'district_summary' },
          { path: '/growth', labelKey: 'growth', permKey: 'growth' },
        ]
      },
      { path: '/apteka-control', labelKey: 'operations', icon: Briefcase, permKey: 'apteka_control',
        children: [
          { path: '/apteka-control', labelKey: 'aptekaControl', permKey: 'apteka_control' },
          { path: '/orders', labelKey: 'ordersNav', permKey: 'apteka_control' },
          { path: '/brain', labelKey: 'brain', icon: Brain, permKey: 'apteka_control' },
          { path: '/deliveries', labelKey: 'deliveries', permKey: 'deliveries' },
          { path: '/payments', labelKey: 'payments', permKey: 'payments' },
          { path: '/payment-calendar', labelKey: 'moneyControl', icon: CalendarDays, permKey: 'payments' },
          { path: '/warehouse', labelKey: 'warehouse', permKey: 'warehouse' },
          { path: '/warehouse/orders', labelKey: 'warehouseOrders', permKey: 'warehouse' },
          { path: '/purchase-orders', labelKey: 'purchaseOrders', permKey: 'warehouse' },
          { path: '/returns', labelKey: 'returns', permKey: 'apteka_control' },
        ]
      },
      { path: '/products', labelKey: 'products', icon: Pill, permKey: 'products',
        children: [
          { path: '/products', labelKey: 'products', permKey: 'products' },
          { path: '/catalog', labelKey: 'catalog', permKey: 'catalog' },
          { path: '/company-catalog', labelKey: 'companyCatalog', permKey: 'company_catalog' },
        ]
      },
      { path: '/inventory-risk', labelKey: 'intelligence', icon: BarChart3, permKey: 'inventory',
        children: [
          { path: '/inventory-risk', labelKey: 'inventoryRisk', permKey: 'inventory' },
          { path: '/product-intelligence', labelKey: 'productIntelligence', permKey: 'inventory' },
          { path: '/sequence-audit', labelKey: 'sequenceAudit', permKey: 'inventory' },
          { path: '/telegram-audit', labelKey: 'telegramAudit', permKey: 'apteka_control' },
          { path: '/reliability-scores', labelKey: 'reliabilityScores', permKey: 'settings' },
          { path: '/pharmacy-dashboard', labelKey: 'pharmacyDashboard', permKey: null },
          { path: '/ai-insights', labelKey: 'aiInsights', permKey: 'dashboard' },
        ]
      },
      { path: '/mr-dashboard', labelKey: 'mrDashboard', icon: Users, permKey: 'mr_dashboard' },
      { path: '/autopilot', labelKey: 'autopilot', icon: Car, permKey: null },
      { path: '/connections', labelKey: 'connections', icon: Link2, permKey: null },
      { path: '/subscription', labelKey: 'subscription', icon: Crown, permKey: null },
      { path: '/month-opening', labelKey: 'monthControl', icon: CalendarCheck, permKey: 'month_closing',
        children: [
          { path: '/month-opening', labelKey: 'monthOpening', permKey: 'month_closing' },
          { path: '/month-closing', labelKey: 'monthClosing', permKey: 'month_closing' },
        ]
      },
      { path: '/settings', labelKey: 'settings', icon: Settings, permKey: 'settings' },
    ]
  },
];

export const MANAGER_SECTIONS = [
  {
    key: 'main', label: '',
    items: [
      { path: '/dashboard', labelKey: 'dashboard', icon: LayoutDashboard, permKey: 'dashboard',
        children: [
          { path: '/dashboard', labelKey: 'dashboard', permKey: 'dashboard' },
          { path: '/district-summary', labelKey: 'districtSummary', permKey: 'district_summary' },
          { path: '/growth', labelKey: 'growth', permKey: 'growth' },
        ]
      },
      { path: '/apteka-control', labelKey: 'operations', icon: Briefcase, permKey: 'apteka_control',
        children: [
          { path: '/apteka-control', labelKey: 'aptekaControl', permKey: 'apteka_control' },
          { path: '/orders', labelKey: 'ordersNav', permKey: 'apteka_control' },
          { path: '/brain', labelKey: 'brain', icon: Brain, permKey: 'apteka_control' },
          { path: '/deliveries', labelKey: 'deliveries', permKey: 'deliveries' },
          { path: '/payments', labelKey: 'payments', permKey: 'payments' },
          { path: '/payment-calendar', labelKey: 'moneyControl', icon: CalendarDays, permKey: 'payments' },
          { path: '/warehouse', labelKey: 'warehouse', permKey: 'warehouse' },
          { path: '/warehouse/orders', labelKey: 'warehouseOrders', permKey: 'warehouse' },
          { path: '/purchase-orders', labelKey: 'purchaseOrders', permKey: 'warehouse' },
          { path: '/returns', labelKey: 'returns', permKey: 'apteka_control' },
          { path: '/mr-dashboard', labelKey: 'mrDashboard', permKey: 'mr_dashboard' },
        ]
      },
      { path: '/products', labelKey: 'products', icon: Pill, permKey: 'products',
        children: [
          { path: '/products', labelKey: 'products', permKey: 'products' },
          { path: '/catalog', labelKey: 'catalog', permKey: 'catalog' },
          { path: '/company-catalog', labelKey: 'companyCatalog', permKey: 'company_catalog' },
        ]
      },
      { path: '/inventory-risk', labelKey: 'intelligence', icon: BarChart3, permKey: 'inventory',
        children: [
          { path: '/inventory-risk', labelKey: 'inventoryRisk', permKey: 'inventory' },
          { path: '/product-intelligence', labelKey: 'productIntelligence', permKey: 'inventory' },
          { path: '/pharmacy-dashboard', labelKey: 'pharmacyDashboard', permKey: null },
          { path: '/ai-insights', labelKey: 'aiInsights', permKey: 'dashboard' },
        ]
      },
      { path: '/autopilot', labelKey: 'autopilot', icon: Car, permKey: null },
      { path: '/month-opening', labelKey: 'monthControl', icon: CalendarCheck, permKey: 'month_closing',
        children: [
          { path: '/month-opening', labelKey: 'monthOpening', permKey: 'month_closing' },
          { path: '/month-closing', labelKey: 'monthClosing', permKey: 'month_closing' },
        ]
      },
      { path: '/settings', labelKey: 'settings', icon: Settings, permKey: null },
    ]
  },
];

export const MR_SECTIONS = [
  {
    key: 'main', label: '',
    items: [
      { path: '/mr-dashboard', labelKey: 'mrDashboard', icon: LayoutDashboard, permKey: null },
      { path: '/apteka-control', labelKey: 'operations', icon: Briefcase, permKey: 'apteka_control',
        children: [
          { path: '/apteka-control', labelKey: 'aptekaControl', permKey: 'apteka_control' },
          { path: '/orders', labelKey: 'ordersNav', permKey: 'apteka_control' },
          { path: '/brain', labelKey: 'brain', icon: Brain, permKey: 'apteka_control' },
          { path: '/deliveries', labelKey: 'deliveries', permKey: 'deliveries' },
          { path: '/payments', labelKey: 'payments', permKey: 'payments' },
          { path: '/payment-calendar', labelKey: 'moneyControl', icon: CalendarDays, permKey: 'payments' },
        ]
      },
      { path: '/pharmacy-dashboard', labelKey: 'pharmacyDashboard', icon: Eye, permKey: null },
      { path: '/company-catalog', labelKey: 'companyCatalog', icon: Building2, permKey: 'company_catalog' },
      { path: '/settings', labelKey: 'settings', icon: Settings, permKey: null },
    ]
  },
];

export const APTEKA_SECTIONS = [
  {
    key: 'main', label: '',
    items: [
      { path: '/pharmacy-dashboard', labelKey: 'pharmacyDashboard', icon: LayoutDashboard, permKey: null },
      { path: '/apteka-control', labelKey: 'aptekaControl', icon: Store, permKey: 'apteka_control' },
      { path: '/apteka-catalog', labelKey: 'myCatalog', icon: Pill, permKey: null },
      { path: '/company-catalog', labelKey: 'companyCatalog', icon: Building2, permKey: 'company_catalog' },
      { path: '/subscription', labelKey: 'subscription', icon: Crown, permKey: null },
      { path: '/settings', labelKey: 'settings', icon: Settings, permKey: null },
    ]
  },
];

// ============ ROLE-SPECIFIC QUICK ACTIONS ============
const ADMIN_QUICK_ACTIONS = [
  { label: 'Add Delivery', icon: Truck, path: '/deliveries', permKey: 'deliveries' },
  { label: 'Record Payment', icon: DollarSign, path: '/payments', permKey: 'payments' },
  { label: 'Add Stock', icon: Boxes, path: '/apteka-control', permKey: 'apteka_control' },
  { label: 'Add Product', icon: Pill, path: '/products', permKey: 'products' },
];

const MANAGER_QUICK_ACTIONS = [
  { label: 'Add Delivery', icon: Truck, path: '/deliveries', permKey: 'deliveries' },
  { label: 'Record Payment', icon: DollarSign, path: '/payments', permKey: 'payments' },
  { label: 'Add Stock', icon: Boxes, path: '/apteka-control', permKey: 'apteka_control' },
];

const MR_QUICK_ACTIONS = [
  { label: 'Update Stock', icon: Boxes, path: '/apteka-control', permKey: null },
  { label: 'Add Delivery', icon: Truck, path: '/deliveries', permKey: null },
  { label: 'Record Payment', icon: DollarSign, path: '/payments', permKey: null },
];

const APTEKA_QUICK_ACTIONS = [];

export function getQuickActions(role) {
  if (['super_admin', 'company_owner', 'company_admin', 'platform_owner', 'platform_admin', 'admin'].includes(role)) return ADMIN_QUICK_ACTIONS;
  if (role === 'manager') return MANAGER_QUICK_ACTIONS;
  if (role === 'mr') return MR_QUICK_ACTIONS;
  return APTEKA_QUICK_ACTIONS;
}

// ============ SIDEBAR STYLE TOKENS ============
export const SB = {
  primary: 'hsl(var(--primary))',
  primaryBg: 'hsl(var(--primary) / 0.1)',
  primaryBgHover: 'hsl(var(--primary) / 0.06)',
  muted: 'hsl(var(--muted-foreground))',
  mutedSoft: 'hsl(var(--muted-foreground) / 0.55)',
  fg: 'hsl(var(--foreground))',
  hoverBg: 'hsl(var(--muted) / 0.5)',
  bg: 'transparent',
  border: 'hsl(var(--border))',
  tooltipBg: 'hsl(var(--foreground))',
  tooltipFg: 'hsl(var(--background))',
  radius: 8,
  transition: '0.15s ease',
};

// ============ DISPLAY MAPS ============
export const ROLE_DISPLAY = {
  platform_owner: 'Platform Owner',
  platform_admin: 'Platform Admin',
  support_admin: 'Support Admin',
  company_owner: 'Owner',
  company_admin: 'Admin',
  manager: 'Manager',
  mr: 'Field Rep',
  pharmacy_owner: 'Owner',
  pharmacy_admin: 'Admin',
  super_admin: 'Owner',
  admin: 'Admin',
  apteka: 'Pharmacy',
};

export const PREVIEW_DISPLAY = {
  manager: 'Manager',
  mr: 'MR',
  pharmacy_owner: 'Connected Pharmacy',
};

export const PREVIEW_ROLES = ['manager', 'mr', 'pharmacy_owner'];
